import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { NavService } from '../../../_services/_nav.service';
import { forkJoin } from 'rxjs';
import { EstructuraFisica } from '../../../_models/estructura-fisica';
import { EstructuraFisicaService } from '../../../_services/estructura-fisica.service';
import { EstructuraFisicaAgricola } from '../../../_models/estructura-fisica-agricola';
import { EstructuraFisicaAgricolaService } from '../../../_services/estructura-fisica-agricola.service';
import { EstructuraFisicaPecuariaService } from '../../../_services/estructura-fisica-pecuaria.service';
import { EstructuraAgricola } from '../../../_models/estructura-agricola';
import { EstructuraAgricolaService } from '../../../_services/estructura-agricola.service';
import { EstructuraPecuaria } from '../../../_models/estructura-pecuaria';
import { EstructuraFisicaPecuaria } from '../../../_models/estructura-fisica-pecuaria';
import { EstructuraPecuariaService } from '../../../_services/estructura-pecuaria.service';

@Component( {
  selector: 'app-estructura-oficina',
  templateUrl: 'estructura-oficina.component.html'
} )

export class EstructuraOficinaComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  estrucFisica: EstructuraFisica;
  formulario: FormGroup;
  submitted = false;
  lisTodasEstructurasAgricolas: EstructuraAgricola[] = [];
  lisEstrucFisicaAgricola: EstructuraFisicaAgricola[] = [];
  lisEstAgrSeleccionadas: EstructuraAgricola[] = [];
  lisEstAgrDisponibles: EstructuraAgricola[] = [];
  lisTodasEstructurasPecuarias: EstructuraPecuaria[] = [];
  lisEstrucFisicaPecuaria: EstructuraFisicaPecuaria[] = [];
  lisEstPecSeleccionadas: EstructuraPecuaria[] = [];
  lisEstPecDisponibles: EstructuraPecuaria[] = [];

  constructor( private serEstructuraFisica: EstructuraFisicaService,
               private serEstrucFisicaAgricola: EstructuraFisicaAgricolaService,
               private serEstrucFisicaPecuaria: EstructuraFisicaPecuariaService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private serEstrucAgricola: EstructuraAgricolaService,
               private serEstrucPecuaria: EstructuraPecuariaService,
               private navServicio: NavService,
               private router: Router ) {
  }

  ngOnInit(): void {

    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        forkJoin( this.serEstructuraFisica.getById( params[ 'id' ] ),
          this.serEstrucFisicaAgricola.listadoPorEstructuraFisica( params[ 'id' ] ),
          this.serEstrucFisicaPecuaria.listadoPorEstructuraFisica( params[ 'id' ] ) ).subscribe( ( [ estructuraFisica, lisEstFisAgr, lisEstFisPec ] ) => {

          this.estrucFisica = estructuraFisica;
          this.lisEstrucFisicaAgricola = lisEstFisAgr;
          this.lisEstrucFisicaPecuaria = lisEstFisPec;
          this.carServiciosIniciales();
        } );
      }
    } );
  }

  carServiciosIniciales() {
    this.formulario = this.fb.group( {
      idEstructuraFisica: [ this.estrucFisica ? this.estrucFisica.idEstructuraFisica : null, [ Validators.required ] ],
      indicadorEstructura: [ true ],
      indicadorHabilitado: [ this.estrucFisica ? this.estrucFisica.indicadorHabilitado : false ],
      auditoriaUsuario: [ this.estrucFisica ? this.estrucFisica.auditoriaUsuario : null ],
      auditoriaFecha: [ this.estrucFisica ? this.estrucFisica.auditoriaFecha : null ],
    } );

    forkJoin( this.serEstrucAgricola.listado(),
      this.serEstrucPecuaria.listado() ).subscribe( ( [ estFisAgr, estFisPec ] ) => {
      this.lisTodasEstructurasAgricolas = estFisAgr.filter( x => x.indicadorHabilitado );
      this.lisTodasEstructurasPecuarias = estFisPec.filter( x => x.indicadorHabilitado );
      this.cargarEstFis();
      this.carInformacionInicial = false;
    } );


  }

  recargarListasEstructuras() {
    this.lisEstrucFisicaAgricola = [];
    this.lisEstrucFisicaPecuaria = [];
    forkJoin( this.serEstrucFisicaAgricola.listadoPorEstructuraFisica( this.estrucFisica.idEstructuraFisica ),
      this.serEstrucFisicaPecuaria.listadoPorEstructuraFisica( this.estrucFisica.idEstructuraFisica ) ).subscribe( ( [ lisEstFisAgr, lisEstFisPec ] ) => {
      this.lisEstrucFisicaAgricola = lisEstFisAgr;
      this.lisEstrucFisicaPecuaria = lisEstFisPec;
      this.cargarEstFis();
    } );
  }

  cargarEstFis() {
    this.lisEstAgrSeleccionadas = [];
    this.lisEstAgrDisponibles = [];
    this.lisEstPecSeleccionadas = [];
    this.lisEstPecDisponibles = [];
    this.lisTodasEstructurasAgricolas.map( ( s: EstructuraAgricola ) => {
      const a = this.lisEstrucFisicaAgricola.find( x => x.idEstructuraAgricola === s.idEstructuraAgricola );
      if ( a && a.indicadorHabilitado ) {
        this.lisEstAgrSeleccionadas.push( s );
      } else {
        this.lisEstAgrDisponibles.push( s );
      }
    } );
    this.lisTodasEstructurasPecuarias.map( ( s: EstructuraPecuaria ) => {
      const a = this.lisEstrucFisicaPecuaria.find( x => x.idEstructuraPecuaria === s.idEstructuraPecuaria );
      if ( a && a.indicadorHabilitado ) {
        this.lisEstPecSeleccionadas.push( s );
      } else {
        this.lisEstPecDisponibles.push( s );
      }
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const formulario = this.formulario.getRawValue();
      if ( formulario.indicadorEstructura ) {
        const actividades = this.generarEstructurasFisicasAgricolas( formulario );
        if ( actividades.length > 0 ) {
          this.serEstrucFisicaAgricola.bulk( actividades ).subscribe( act => {
            this.recargarListasEstructuras();
            this.guardando = false;
            this.submitted = false;
            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'ESTRUCTURAAGRICOLA.LBL_REGGUAR' )
            } );
          } );
        } else {
          this.guardando = false;
          this.submitted = false;
          this.navServicio.setMesage( 0, {
            severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'ESTRUCTURAAGRICOLA.LBL_REGGUAR' )
          } );
        }
      } else {
        const actividades = this.generarEstructurasFisicasPecuarias( formulario );
        if ( actividades.length > 0 ) {
          this.serEstrucFisicaPecuaria.bulk( actividades ).subscribe( act => {
            this.recargarListasEstructuras();
            this.guardando = false;
            this.submitted = false;
            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'ESTRUCTURAAGRICOLA.LBL_REGGUAR' )
            } );
          } );
        } else {
          this.guardando = false;
          this.submitted = false;
          this.navServicio.setMesage( 0, {
            severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'ESTRUCTURAAGRICOLA.LBL_REGGUAR' )
          } );

        }
      }
    }
  }

  generarEstructurasFisicasAgricolas( estFisica: EstructuraFisica ): EstructuraFisicaAgricola[] {
    const datInsertar = [];
    this.lisEstAgrSeleccionadas.map( ( s: EstructuraAgricola ) => {
      const a = this.lisEstrucFisicaAgricola.find( x => x.idEstructuraAgricola === s.idEstructuraAgricola );
      if ( a && !a.indicadorHabilitado ) {
        a.indicadorHabilitado = true;
        datInsertar.push( a );
      } else if ( !a ) {
        const nueActividad = {} as EstructuraFisicaAgricola;
        nueActividad.idEstructuraAgricola = s.idEstructuraAgricola;
        nueActividad.idEstructuraFisica = estFisica.idEstructuraFisica;
        nueActividad.indicadorHabilitado = true;
        datInsertar.push( nueActividad );
      }
    } );

    this.lisEstrucFisicaAgricola.map( ( s: EstructuraFisicaAgricola ) => {
      const inhabilitar = this.lisEstAgrSeleccionadas.find( x => x.idEstructuraAgricola === s.idEstructuraAgricola );
      if ( !inhabilitar && s.indicadorHabilitado ) {
        s.indicadorHabilitado = false;
        datInsertar.push( s );
      }
    } );

    return datInsertar;
  }

  generarEstructurasFisicasPecuarias( estFisica: EstructuraFisica ): EstructuraFisicaPecuaria[] {
    const datInsertar = [];
    this.lisEstPecSeleccionadas.map( ( s: EstructuraPecuaria ) => {
      const a = this.lisEstrucFisicaPecuaria.find( x => x.idEstructuraPecuaria === s.idEstructuraPecuaria );
      if ( a && !a.indicadorHabilitado ) {
        a.indicadorHabilitado = true;
        datInsertar.push( a );
      } else if ( !a ) {
        const nueActividad = {} as EstructuraFisicaPecuaria;
        nueActividad.idEstructuraPecuaria = s.idEstructuraPecuaria;
        nueActividad.idEstructuraFisica = estFisica.idEstructuraFisica;
        nueActividad.indicadorHabilitado = true;
        datInsertar.push( nueActividad );
      }
    } );

    this.lisEstrucFisicaPecuaria.map( ( s: EstructuraFisicaPecuaria ) => {
      const inhabilitar = this.lisEstPecSeleccionadas.find( x => x.idEstructuraPecuaria === s.idEstructuraPecuaria );
      if ( !inhabilitar && s.indicadorHabilitado ) {
        s.indicadorHabilitado = false;
        datInsertar.push( s );
      }
    } );

    return datInsertar;
  }

  regresar( dirty: boolean ) {
    if ( dirty || this.validarCambios() ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  volver() {
    this.router.navigate( [ 'apl/estructura-fisica/' ] );
  }

  mensajeConfirmacion() {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'ESTRUCOFICINA.MSG_MSJCANSEL' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      accept: () => {
      },
      reject: () => {
        this.f.indicadorEstructura.setValue( !this.f.indicadorEstructura.value );
      }
    } );
  }

  validarCambios(): boolean {
    return this.lisEstrucFisicaAgricola.length !== this.lisEstAgrSeleccionadas.length ||
      this.lisEstrucFisicaAgricola.filter( x => this.lisEstAgrSeleccionadas.find( y => y.idEstructuraAgricola === x.idEstructuraAgricola ) !== undefined ).length !== this.lisEstrucFisicaAgricola.length;
  }


  get f() {
    return this.formulario.controls;
  }


}
